// We are relying on jQuery being called in a separate script file.
var $ = window.jQuery;



const settings = {
    classes: ''
};


function getRandomInt(min = 1, max = 999) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}




export default class {

    // Starts here.
    constructor() {
        this.init();
    }

    init() {
        if (window.toggler) {
            return window.toggler;
        } else {
            this.setCache();
            this.bindEvents();
            window.toggler = this;
        }

    }



    // cache DOM elements when possible for performance
    setCache () {
        this.cache = {};
        this.cache.body = $(document.body); // lots of woocommerce events get fired here.
    }


    // bind the different events that interact with the component
    bindEvents () {
        this.cache.body.on('click', '[data-toggler]', this.toggleByDataAttributes.bind(this));
        this.cache.body.on('keyup', this.keyBoardEvents.bind(this));
    }

    getOverlay() {
        var overlay = $('.js-overlay--default');

        if (!overlay.length) {
            var template = `<div class="overlay overlay--default js-overlay--default"></div>`;
            overlay = $(template).hide();
            this.cache.body.append(overlay);
        }

        return overlay;
    }

    keyBoardEvents(e) {
        if (e && e.keyCode && e.keyCode == 27) {
            this.cache.body.trigger('key_escape');
        }
    }

    // open a modal via data attributes.
    // TODO: Make this smarter, and less of a mess.
    toggleByDataAttributes(clickEvent) {
        // console.log("toggle");
        clickEvent.preventDefault();
        var trigger = $(clickEvent.target).closest('[data-toggler]');
        var data = trigger.data();
        var target = $(data.target);
        var targetClass = data.class ? data.class : 'is-open';
        var bodyClass = data.bodyClass ? data.bodyClass : false;
        var overlay = data.overlay ? this.getOverlay() : false;
        var blur = data.blur === false ? false : true;

        console.log(data.blur, blur);

        // console.log(data);

        if (!trigger.hasClass('is-active')) {



            trigger.addClass('is-active');
            target.addClass(targetClass);
            this.cache.body.addClass(bodyClass);

            if (data.overlay) {
                overlay.show();
            }


            var id = data.togglerId ? data.togglerId : getRandomInt();

            if (!data.class) {
                target.toggle();
            }

            var that = this;

            function closeThis(e) {
                // if there was an event, prevent default.
                if (e && e.target) {
                    e.preventDefault();
                }

                var container = $(target);

                if (!data.class) {
                    container.hide();
                }

                if (data.overlay) {
                    overlay.hide();
                }

                // remove close binding on trigger.
                trigger.off('click.' + id);

                that.cache.body.off('mouseup.' + id);
                target.off('click.data');
                if (bodyClass) {
                    that.cache.body.removeClass(bodyClass);
                }
                setTimeout(()=> {
                    trigger.removeClass('is-active');
                    target.removeClass(targetClass);
                }, 1);
            }

            target.on('click.data', '[data-close]', closeThis);

            // bind close to the trigger as well.
            trigger.one('click.' + id, closeThis);

            if (blur !== false) {
                this.cache.body.one('key_escape', closeThis);

                this.cache.body.on('mouseup.' + id,  (mouseUpEvent) =>
                {
                    // console.log("mouseup");
                    var container = $(target);



                    // if the target of the click isn't the container...
                    if ((!container.hasClass(targetClass) || (!container.is(mouseUpEvent.target) && container.has(mouseUpEvent.target).length === 0))) // ... nor a descendant of the container
                    {
                        closeThis();
                    }

                });
            }
        }




    }




}
